import client from '../client';
import type { ApiResponse } from '../../types/api';

export interface MenuItem {
  title: string;
  link: string;
  type: 'all-categories' | 'all-categories-with-children' | 'category' | 'product' | 'custom' | 'user-page';
  categoryId?: string;
  icon?: string;
  iconImage?: string;
  openInNewTab?: boolean;
  children?: MenuItem[];
}

export interface StoreMenus {
  header: MenuItem[];
  footer: MenuItem[];
  userMenu: MenuItem[];
}

export const menusApi = {
  get: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ menus: StoreMenus }>>(
      `/dashboard/${storeId}/menus`,
    );
    return res.data.data!;
  },

  save: async (storeId: string, menus: StoreMenus) => {
    const res = await client.post<ApiResponse<{ menus: StoreMenus }>>(
      `/dashboard/${storeId}/menus`,
      { menus },
    );
    return res.data.data!;
  },
};
